import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import { Stack } from '@eluve/components';
import { TabLink, TabNav } from '@eluve/smart-blocks';

import { PatientProfile } from './PatientProfile';
import { TabActionsSlotContext } from './TabActionsSlotContext';

// "Medical Profile" tab: the FHIR record (PatientProfile) is the always-on
// header; data views below switch via the secondary tab bar + nested Outlet.
const subTabs: TabLink[] = [
  { name: 'Care Team', link: 'care-team' },
  { name: 'Observations', link: 'observations' },
  { name: 'Patient Uploads', link: 'patient-uploads' },
];

export const MedicalProfile: React.FC = () => {
  // The tab bar's right-hand actions slot, handed to the active sub-tab via
  // context so it can portal its own tab-scoped controls beside the tabs.
  const [actionsSlot, setActionsSlot] = useState<HTMLDivElement | null>(null);

  return (
    <Stack gap={6}>
      <PatientProfile />
      <Stack gap={4}>
        <TabNav
          tabs={subTabs}
          actions={<div ref={setActionsSlot} className="flex items-center" />}
        />
        <TabActionsSlotContext.Provider value={actionsSlot}>
          <Outlet />
        </TabActionsSlotContext.Provider>
      </Stack>
    </Stack>
  );
};
